"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const DateDropdownGroup_1 = __importDefault(require("./DateDropdownGroup"));
const use_date_select_1 = require("../../use-date-select");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DateSelect = react_1.default.forwardRef((_a, ref) => {
    var { value, onChange, hideDay } = _a, dateSelectOpts = __rest(_a, ["value", "onChange", "hideDay"]);
    const useDateSelectInterface = (0, use_date_select_1.useDateSelect)(value, onChange, Object.assign(Object.assign({}, dateSelectOpts), { defaultDay: dateSelectOpts.defaultDay
            ? dateSelectOpts.defaultDay
            : hideDay
                ? 1
                : undefined }));
    return ((0, jsx_runtime_1.jsx)(DateDropdownGroup_1.default, Object.assign({}, useDateSelectInterface, { hideDay: hideDay, ref: ref })));
});
DateSelect.displayName = "DateSelect";
exports.default = DateSelect;
